// extracted by mini-css-extract-plugin
module.exports = {"sticky":"covidWarning_sticky__2M2CU","background":"covidWarning_background__c4rAP","content":"covidWarning_content__3iER0"};